import { isBad, isGood } from "@/lib/gardenChecks";

const pairScore = (a, b, d, gap) => {
  let s = 0;
  if (d === 1) {
    if (isBad(a, b)) s -= 6;
    else if (isGood(a, b)) s += 1;
  }
  if (gap && d <= Math.max(gap(a), gap(b))) s -= 2;
  return s;
};

function score(items, vegs, gap) {
  let s = 0;
  for (let i = 0; i < items.length; i++) for (let j = i + 1; j < items.length; j++) {
    const d = Math.max(Math.abs(items[i].col - items[j].col), Math.abs(items[i].row - items[j].row));
    s += pairScore(vegs[i], vegs[j], d, gap);
  }
  return s;
}

export function stats(items, vegBySlug) {
  let good = 0, bad = 0;
  for (let i = 0; i < items.length; i++) for (let j = i + 1; j < items.length; j++) {
    const a = vegBySlug[items[i].slug], b = vegBySlug[items[j].slug];
    if (!a || !b) continue;
    const d = Math.max(Math.abs(items[i].col - items[j].col), Math.abs(items[i].row - items[j].row));
    if (d !== 1) continue;
    if (isBad(a, b)) bad++; else if (isGood(a, b)) good++;
  }
  return { good, bad };
}

// Shuffles crops across the same occupied squares to maximise good neighbours. Returns new items.
export function autoArrange(items, vegBySlug, gap = null, iterations = 4000) {
  iterations = Math.min(iterations, Math.floor(2e7 / Math.max(1, items.length ** 2)));
  const pos = items.map((p) => ({ col: p.col, row: p.row }));
  let order = items.map((_, i) => i);
  const build = (ord) => ord.map((idx, k) => ({ ...items[idx], col: pos[k].col, row: pos[k].row }));
  const vegsOf = (ord) => ord.map((idx) => vegBySlug[items[idx].slug] || { name: "", companions_good: [], companions_bad: [] });
  let cur = score(build(order), vegsOf(order), gap);
  let best = order.slice(), bestScore = cur;
  let temp = 3;
  for (let t = 0; t < iterations && items.length > 1; t++) {
    const i = Math.floor(Math.random() * order.length), j = Math.floor(Math.random() * order.length);
    if (i === j || items[order[i]].slug === items[order[j]].slug) continue;
    const next = order.slice(); [next[i], next[j]] = [next[j], next[i]];
    const s = score(build(next), vegsOf(next), gap);
    if (s >= cur || Math.random() < Math.exp((s - cur) / temp)) {
      order = next; cur = s;
      if (s > bestScore) { best = next.slice(); bestScore = s; }
    }
    temp = Math.max(0.05, temp * 0.999);
  }
  return build(best);
}
